<template>
    <main class="doughnut__labels">

        <div class="label">
            <h2 class="label__header">Tillgångar</h2>
            <LabelItem class="label__asset" v-for="(label, index) in userData.pension" :label="label" :index="index" :key="index+'pension'" />
            <LabelItem class="label__asset" v-for="(label, index) in userData.income" :label="label" :hasLabel="hasLabel" :index="index" :choices="userData.choices" :key="index+'income'" />
        </div>
        <div class="label">
            <h2 class="label__header">Skulder</h2>
            <LabelItem class="label__debt" v-for="(label, index) in data.debts" :label="label" :index="index" :key="index+'debts'" />
        </div>

    </main>
</template>

<script>
import LabelItem from './LabelItem';


export default {
    data() {
        return {
            data: [],
            hasLabel: true
        }
    },
    components: {
        LabelItem
    },
    computed: {
        userData() {
            return this.$store.state.userData;
        },
        choices() {
            return this.$store.state.choices;
        }
    },
    methods: {
        getTotal() {
            let incomes = this.userData.income;
            let choices = this.choices;

            var estates = choices.filter(choice => choice.parent === "Fastigheter");
            var vehicles = choices.filter(choice => choice.parent === "Fordon");
            var other = choices.filter(choice => choice.parent === "Övrigt");

            this.$store.commit('setSettingItems', { estates, vehicles, other } );

            incomes.filter(income => {
                if (income.type === "Fastigheter") {
                    return income.value = estates.reduce((acc, obj) => acc + Number(obj.value), 0);
                } else if (income.type === "Fordon") {
                    return income.value = vehicles.reduce((acc, obj) => acc + Number(obj.value), 0);
                } else {
                    return income.value = other.reduce((acc, obj) => acc + Number(obj.value), 0);
                }
            })

        },
    },
    watch: {
        userData: function() {
            this.getTotal();
        }
    }
}
</script>
